import React from 'react'
import BookACallButton from '../Buttons/Specials/BookACallButton'
import HomepageBookCallLeadModal from '../Modals/HomepageBookCallLeadModal'

const ROOFING_MODAL_PROPS = {
    meetingTitle: 'Book a Call With a Direct Mail Expert Now',
    formName: 'Roofing Direct Mail Strategy Call',
}

const defaultHeading = 'Ready to Grow Your Roofing Business With Direct Mail?'
const defaultSubheading =
    'Let OLM design a campaign that brings in more calls, inspections, and roofing contracts'
const defaultCTA = {
    label: 'Book a Call With a Direct Mail Expert Now',
    href: '/free-coaching-call',
}

const defaultGradient =
    'linear-gradient(103.29deg, #F15A22 4.82%, #FAB132 98.82%)'

export default function CtaBanner(props) {
    const heading = props?.heading || defaultHeading
    const subheading = props?.subheading || defaultSubheading
    const cta = props?.cta || defaultCTA
    const gradient = props?.gradient || defaultGradient

    return (
        <section className="relative z-22" style={{ background: gradient }}>
            <div className="relative z-10 container mx-auto px-4 py-12 sm:py-16">
                <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8 lg:gap-10 justify-between">
                    {/* Copy */}
                    <div className="flex-1 max-w-xl text-center md:text-left">
                        <h2 className="text-white text-2xl sm:text-[40px] font-bold leading-tight">
                            {heading}
                        </h2>
                        {subheading ? (
                            <p className="mt-4 text-white/90 text-base sm:text-xl lg:text-xl max-w-3xl font-normal">
                                {subheading}
                            </p>
                        ) : null}
                    </div>

                    {/* CTA */}
                    {cta?.label ? (
                        <div className="w-full lg:w-auto text-center">
                            {/* <a
                                href={cta.href || '#'}
                                className="inline-flex w-full lg:w-auto items-center justify-center rounded-md bg-white px-6 sm:px-8 py-4 text-olm-new-black text-sm md:text-2xl text-center font-bold shadow-[0_8px_20px_rgba(0,0,0,0.15)] hover:translate-y-[1px] transition-transform">
                                {cta.label}
                            </a> */}
                            <div className="max-w-xs md:max-w-sm mx-auto md:mx-0">
                                <BookACallButton
                                    scheme="white"
                                    Modal={HomepageBookCallLeadModal}
                                    modalProps={ROOFING_MODAL_PROPS}>
                                    {cta.label}
                                </BookACallButton>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        </section>
    )
}
